module.exports = __webpack_public_path__ + "img/Group 97680.8fbe000c.png";